<template>
  <div class="pg">
    <div class="pg_text pb_4 fs_12 scale08_bot">{{ desc }}</div>
    <div class="pg_main">
      <div class="pg_wrap" :style="{ border: `1px solid ${ skins.borderColor || '#c73534'}` }">
        <div
          class="pg_cxt"
          :style="{
            width: progressVal + '%',
            background: skins.background,
          }"
        ></div>
      </div>
      <div class="pg_max fs_12 scale08_bot" :style="{ color: skins.color }">{{ targetVal }}</div>
      <div
        class="pg_current fs_12 scale08_bot"
        :class="{ pg_current_value0: progressVal <= 1.5 }"
        :style="{ left: progressVal + '%', color: skins.color }"
      >{{ currentVal }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    desc: {
      type: String,
      default: '当前进度'
    },
    currentVal: {
      type: Number,
      default: 1
    },
    targetVal: {
      type: Number,
      default: 100
    },
    skins: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    progressVal () {
      return this.currentVal / this.targetVal * 100
    }
  },
}
</script>
<style lang="scss" scoped>
.pg {
  margin: 0 auto;
  .pg_text {
    display: inline-block;
    color: #747474;
  }
  .pg_main {
    position: relative;
    padding-bottom: 16px;
    .pg_wrap {
      position: relative;
      width: 100%;
      height: 8px;
      border-radius: 4px;
      // transform: scaleY(.5);
      border: 1px solid #c73534;
    }
    .pg_cxt {
      position: absolute;
      display: inline-block;
      top: 0px;
      border-radius: 4px;
      height: 6px;
      background: linear-gradient(0deg,#fe766b 0%, #fdb46b 100%) #94e1f8;
    }
    .pg_max, .pg_current {
      position: absolute;
      top: 14px;
      color: #C73534;
      &::before {
        content: '·';
        position: absolute;
        top: -9px;
        left: 50%;
        transform: translate(-50%);
      }
    }
    .pg_current {
      left: 0;
      transform: translateX(calc(-50% - 1px));
    }
    .pg_current_value0 {
      transform: translateX(calc(-50% + 3px));
    }
    .pg_max {
      bottom: 32px;
      top: unset;
      left: unset;
      transform: translateX(calc(50% - 3px));
      right: 0;
      &::before {
        top: unset;
        bottom: -8px;
      }
    }
  }
}
</style>